import {
  readonly,
  ref,
} from 'vue'


const userNames = ref<Map<string, string>>(new Map())

export function useLabelerUserNames () {
  function getUserNameById (id?: string): string | undefined {
    if (!id) return undefined
    return userNames.value.get(id)
  }

  function setUserName (userId: string, userName: string): void {
    userNames.value.set(userId, userName)
  }

  return {
    getUserNameById,
    setUserName,
    userNames: readonly(userNames),
  }
}
